module.exports = {
          srcSet: __webpack_public_path__ + "public/images/1e727dabc7c34d0881f3d5bdf0eb29e6-628.webp"+" 628w",
          images:[ {path: __webpack_public_path__ + "public/images/1e727dabc7c34d0881f3d5bdf0eb29e6-628.webp",width: 628,height: 417}],
          src: __webpack_public_path__ + "public/images/1e727dabc7c34d0881f3d5bdf0eb29e6-628.webp",
          toString:function(){return __webpack_public_path__ + "public/images/1e727dabc7c34d0881f3d5bdf0eb29e6-628.webp"},
          
          width: 628,
          height: 417
        }